import request from '@/utils/request'

//获取模板列表
export function getTemplateList(data){
    return request({
        url:'/api/cont_tpl_list',
        method:'post',
        data
    })
}
//新增模板
export function addTemplate(data){
    return request({
        url:'/api/create_cont_tpl',
        method:'post',
        data
    })
}
//查看制作说明
export function viewExplanation(){
    return request({
        url:'/api/zhizuo_desc_url',
        method:'post',
    })
}
//查看签署方配置列表
export function viewSignDeploy(data){
    return request({
        url:'/api/cont_tpl_scan_signers',
        method:'post',
        data
    })
}
//新增签署方
export function addSignDeploy(data){
    return request({
        url:'/api/cont_tpl_create_signers',
        method:'post',
        data
    })
}
//编辑签署方
export function editSignDeploy(data){
    return request({
        url:'/api/cont_tpl_edit_signers',
        method:'post',
        data
    })
}
//删除签署方
export function deleteSignDeploy(data){
    return request({
        url:'/api/cont_tpl_delete_signers',
        method:'post',
        data
    })
}
//下一步编辑模板
export function nextEditTemplate(data){
    return request({
        url:'/api/xiayibu_edit_tpl',
        method:'post',
        data
    })
}
//编辑合同模板
export function editContractTemplate(data){
    return request({
        url:'/api/edit_cont_tpl',
        method:'post',
        data
    })
}
//启用禁用合同模板
export function enableDisableTemplate(data){
    return request({
        url:'/api/cont_tpl_qiyong_jinyong',
        method:'post',
        data
    })
}
//获取企业员工列表
export function getEnterpriseStaffList(){
    return request({
        url:'/api/com_ygall_list',
        method:'post'
    })
}
// 合同模板授权给企业员工使用
export function empowerEmployees(data){
    return request({
        url:'/api/cont_tpl_toyuangong',
        method:'post',
        data
    })
}
//获取已授权企业员工列表
export function getAuthorizedList(data){
    return request({
        url:'/api/com_ysqygall_list',
        method:'post',
        data
    })
}
//取消授权合同模板
export function cancelAuthorization(data){
    return request({
        url:'/api/cont_tpl_cancel_auth',
        method:'post',
        data
    })
}
//删除合同模板
export function deleteContractTemplate(data){
    return request({
        url:'/api/delete_cont_tpl',
        method:'post',
        data
    })
}